import type { StateCreator } from 'zustand';

export type OpenCreateProfileModalOptions = {
  autoSelectOnCreate?: boolean;
};

export type UiState = {
  showCreateProfileModal: boolean;
  createProfileAutoSelectOnCreate: boolean;
  openCreateProfileModal: (
    options?: OpenCreateProfileModalOptions | boolean
  ) => void;
  closeCreateProfileModal: () => void;

  showCreateGroupModal: boolean;
  openCreateGroupModal: () => void;
  closeCreateGroupModal: () => void;

  showProfileGroupSelectorModal: boolean;
  openProfileGroupSelectorModal: () => void;
  closeProfileGroupSelectorModal: () => void;
};

export const createUiSlice: StateCreator<UiState, [], [], UiState> = (set) => ({
  showCreateProfileModal: false,
  createProfileAutoSelectOnCreate: true,
  openCreateProfileModal: (options) => {
    const autoSelectOnCreate =
      typeof options === 'object' && options != null
        ? (options.autoSelectOnCreate ?? true)
        : true;
    set({
      showCreateProfileModal: true,
      createProfileAutoSelectOnCreate: autoSelectOnCreate,
    });
  },
  closeCreateProfileModal: () =>
    set({
      showCreateProfileModal: false,
      createProfileAutoSelectOnCreate: true,
    }),

  showCreateGroupModal: false,
  openCreateGroupModal: () => set({ showCreateGroupModal: true }),
  closeCreateGroupModal: () => set({ showCreateGroupModal: false }),

  showProfileGroupSelectorModal: false,
  openProfileGroupSelectorModal: () =>
    set({ showProfileGroupSelectorModal: true }),
  closeProfileGroupSelectorModal: () =>
    set({ showProfileGroupSelectorModal: false }),
});
